export const profilesPages = {
  computed: {
    profilesPages() {
      return [
        {
          text: 'Marketing',
          value: 'marketing',
          has_pii_access: true,
          pages: [
            'home',
            'clube/desempenho',
            'clube/dashboard',
            'clube/comparativo',
            'clube/lojas',
            'maria/quando-vou-vender',
            'maria/produtos-impulsionadores',
            'clientes/segmentacao',
            'clientes/perfil_demografico',
            'clientes/mapa',
            'clientes/retencao',
            'clientes/interesses/genero',
            'clientes/interesses/idade',
            'clientes/interesses/pessoa_juridica',
            'clientes/melhores_clientes',
            'clientes/busca_cliente',
            'clientes/detalhes_cliente',
            'clientes/consultar-ofertas',
            'produtos/busca_produto',
            'produtos/ranking_produtos',
            'produtos/comparativo_produtos',
            'produtos/detalhes_produto',
            'produtos/gerenciamento_produtos',
            'produtos/faixas_precos',
            'campanhas/calendario_promocional',
            'campanhas/resultados_gerais',
            'campanhas/whatsapp',
            'campanhas/sms',
            'campanhas/email',
            'campanhas/gestao_ofertas/ofertas',
            'campanhas/aplicativo',
            'campanhas/resultados_encarte',
            'configuracoes/lojas',
            'configuracoes/redes-sociais',
            'configuracoes/site-cadastramento',
            'mobile/chatbot',
            'mobile/encartes',
          ],
        },
        {
          text: 'Comercial',
          value: 'comercial',
          has_pii_access: false,
          pages: [
            'home',
            'clube/desempenho',
            'clube/dashboard',
            'clube/comparativo',
            'clube/lojas',
            'maria/quando-vou-vender',
            'maria/produtos-impulsionadores',
            'clientes/segmentacao',
            'produtos/busca_produto',
            'produtos/ranking_produtos',
            'produtos/comparativo_produtos',
            'produtos/gerenciamento_produtos',
            'produtos/detalhes_produto',
            'produtos/faixas_precos',
            'campanhas/calendario_promocional',
            'campanhas/resultados_gerais',
            'campanhas/whatsapp',
            'campanhas/sms',
            'campanhas/email',
            'mobile/encartes',
            'campanhas/gestao_ofertas/ofertas',
            'campanhas/aplicativo',
            'campanhas/resultados_encarte',
            'mobile/chatbot',
          ],
        },
        {
          text: 'Dono',
          value: 'dono',
          has_pii_access: true,
          pages: [
            'home',
            'clube/desempenho',
            'clube/dashboard',
            'clube/comparativo',
            'clube/lojas',
            'clube/performance_operacional',
            'empresa/faturamento',
            'empresa/desempenho',
            'empresa/decomposicao',
            'maria/quando-vou-vender',
            'clientes/segmentacao',
            'clientes/perfil_demografico',
            'clientes/mapa',
            'clientes/retencao',
            'clientes/interesses/genero',
            'clientes/interesses/idade',
            'clientes/interesses/pessoa_juridica',
            'clientes/melhores_clientes',
            'clientes/busca_cliente',
            'clientes/detalhes_cliente',
            'clientes/gerenciamento',
            'clientes/consultar-ofertas',
            'produtos/busca_produto',
            'produtos/detalhes_produto',
            'produtos/ranking_produtos',
            'produtos/arvore_produtos',
            'produtos/comparativo_produtos',
            'produtos/gerenciamento_produtos',
            'pedidos/controle-pedidos',
            'pedidos/gerenciamento-preco',
            'mobile/banners',
            'mobile/ofertas',
            'mobile/pontos',
            'mobile/desempenho',
            'campanhas/calendario_promocional',
            'campanhas/resultados_gerais',
            'campanhas/whatsapp',
            'campanhas/sms',
            'campanhas/email',
            'mobile/encartes',
            'campanhas/gestao_ofertas/ofertas',
            'campanhas/aplicativo',
            'campanhas/resultados_encarte',
            'mobile/chatbot',
            'configuracoes/lojas',
            'configuracoes/redes-sociais',
            'configuracoes/site-cadastramento',
            'configuracoes/gerais',
          ],
        },
        {
          text: 'Externo',
          value: 'externo',
          has_pii_access: false,
          pages: [
            'home',
            'campanhas/calendario_promocional',
            'campanhas/resultados_gerais',
            'campanhas/whatsapp',
            'campanhas/sms',
            'campanhas/email',
            'mobile/encartes',
            'campanhas/gestao_ofertas/ofertas',
            'campanhas/aplicativo',
            'campanhas/resultados_encarte',
            'mobile/chatbot',
          ],
        },
        {
          text: 'TI',
          value: 'ti',
          has_pii_access: false,
          pages: [
            'home',
            'clube/desempenho',
            'clube/dashboard',
            'clube/comparativo',
            'clube/lojas',
            'clube/performance_operacional',
            'empresa/faturamento',
            'empresa/desempenho',
            'empresa/decomposicao',
            'maria/quando-vou-vender',
            'clientes/segmentacao',
            'clientes/perfil_demografico',
            'clientes/mapa',
            'clientes/retencao',
            'clientes/interesses/genero',
            'clientes/interesses/idade',
            'clientes/interesses/pessoa_juridica',
            'clientes/melhores_clientes',
            'clientes/busca_cliente',
            'clientes/detalhes_cliente',
            'clientes/gerenciamento',
            'produtos/busca_produto',
            'produtos/detalhes_produto',
            'produtos/ranking_produtos',
            'produtos/arvore_produtos',
            'produtos/comparativo_produtos',
            'produtos/gerenciamento_produtos',
            'pedidos/controle-pedidos',
            'pedidos/gerenciamento-preco',
            'mobile/banners',
            'mobile/ofertas',
            'mobile/pontos',
            'mobile/desempenho',
            'campanhas/calendario_promocional',
            'campanhas/resultados_gerais',
            'campanhas/whatsapp',
            'campanhas/sms',
            'campanhas/email',
            'mobile/encartes',
            'campanhas/gestao_ofertas/ofertas',
            'campanhas/aplicativo',
            'campanhas/resultados_encarte',
            'mobile/chatbot',
            'configuracoes/lojas',
            'configuracoes/redes-sociais',
            'configuracoes/site-cadastramento',
            'configuracoes/gerais',
          ],
        },
        {
          text: 'Supervisor de loja',
          value: 'supervisor_loja',
          has_pii_access: true,
          pages: ['home', 'clientes/consultar-ofertas'],
        },
      ]
    },
    ecommerceProfiles() {
      return [
        {
          text: 'Administrador',
          value: 'admin',
        },
        {
          text: 'Supervisor',
          value: 'supervisor',
          permissions: ['view_pedido', 'change_pedido', 'add_itempedido', 'change_itempedido', 'delete_itempedido', 'view_itempedido', 'view_produto'],
        },
        {
          text: 'Separador',
          value: 'separator',
          permissions: ['view_pedido', 'change_pedido', 'add_itempedido', 'change_itempedido', 'delete_itempedido', 'view_itempedido', 'view_produto'],
        },
        {
          text: 'Entregador',
          value: 'delivery_man',
          permissions: ['view_pedido', 'change_pedido'],
        },
      ]
    },
  },
}
